<template>
    <div>
        <Header></Header>
        <div class="new_detail">
            <div class="container">
                <div class="content_box">
                    <div class="content_bottom flex_box" >
                        安全验证：<input type="password" v-model="accont">
                        <div class="yz" @click="adminLogin">验证</div>
                    </div>
                </div> 
            </div>
            
            <!-- 背景 -->
            <img class="detail_bg" src="/NewDetail/img/bg.jpg" width="100%">
        </div>
        <Footer></Footer>
    </div>
  
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import {adminLogin} from '@/api/http.js'
    export default {
  components: { Header, Footer },
        data() {
            return {
                uid:'',
                accont:''
            }
        },
        methods:{
            adminLogin(){
                adminLogin({
                    uid:this.uid,
                    password:this.accont
                }).then((res)=>{
                    if(res.code == 200){
                        localStorage.setItem('token',res.data.token)
                        this.$message({
                            message: res.msg,
                            type: 'success',
                            onClose:()=>{
                                this.$router.push({
                                    path:'/home'
                                })
                                location.reload()
                            },
                            duration: 1500
                        });
                    }
                }).catch((err)=>{
                    console.log('捕获异常',err)
                    this.$message({
                        message: err.msg,
                        type: 'warning',
                        duration: 1500
                    });
                })
            }
        },
        created(){
            if(this.$route.query.uid){
                this.uid = this.$route.query.uid
            }
        }
    }
</script>

<style scoped>
.yz{
    padding: 0 10px;
    border: 1px solid black;
    cursor: pointer;
}
.new_detail{
    position: relative;
    overflow: hidden;
    top: 0;
    left: 0;
    padding: 10px 0;
    margin-top: 110px;
    background: #18181a;
}
.detail_bg{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}
.content_box{
    position: relative;
    z-index: 2;
    background: #FAFAFA;
    border-radius: 4px;
    min-height: 800px;
}

.content_bottom{
    padding: 30px;
    height: 100%;
}

.new_content{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #4D4D4D;
    margin-top: 15px;
}
@media (max-width:1600px) {

    .content_bottom{
        padding: 20px;
    }
    .new_content{
        font-size: 12px;
    }
}
@media (max-width: 1300px){
    .new_detail{
        margin-top: 100px;
    }
    .content_bottom{
        padding:10px 20px;
    }
}

</style>